import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateNote, IUpdateNoteParams } from '../../actions/favoriteEntities/notes';
import { CommentForm, ICommentFormProps } from '../../components/CommentForm';
import { TThunkDispatch, IApplicationState } from '../../types/redux';
import { trackCommentSend } from './trackings';

type TCommentFormDispatchProps = Pick<ICommentFormProps, 'onSubmitComment'>;
type TCommentFormOwnProps = Pick<ICommentFormProps, 'entityId'>;

function mapDispatchToProps(dispatch: TThunkDispatch) {
  return {
    onSubmitComment: bindActionCreators(updateNote, dispatch),
  };
}

function mergeProps(state: IApplicationState, actions: TCommentFormDispatchProps, ownProps: TCommentFormOwnProps) {
  return {
    ...state,
    ...actions,
    ...ownProps,
    onSubmitComment: (params: IUpdateNoteParams) => {
      actions.onSubmitComment({
        entityId: params.entityId,
        comment: params.comment,
      });
      trackCommentSend();
    },
  };
}

export const CommentFormContainer = connect(undefined, mapDispatchToProps, mergeProps)(CommentForm);
